import { StyleSheet, Dimensions } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const screenHeight = Dimensions.get('screen').height;
const modalHeight = screenHeight * 0.65;
export default StyleSheet.create({
  failureViewContainer: {
    height: modalHeight,
  },
  failureTextContainer: {
    flex: 1,
    marginTop: -53,
    justifyContent: 'center',
  },
  titleStyle: {
    fontSize: 24,
    fontFamily: Fonts.type.VFFont,
    fontWeight: '700',
    color: Colors.dark_grey,
  },
  secondaryButton: {
    marginBottom: screenHeight < 800 ? -10 : 0,
  },
});
